import {
    AfterViewInit,
    Component,
    HostListener,
    Inject,
    Input,
    OnInit,
    ViewChild,
} from "@angular/core";
import * as moment from "moment";
import { SEVERITY_TYPES, statusType, Tickets } from "../tickets";
import {
    AbstractControl,
    FormBuilder,
    FormGroup,
    ValidationErrors,
    ValidatorFn,
    Validators,
} from "@angular/forms";
import { TableRefreshService } from "../table-refresh.service";
import { TicketsService } from "../tickets.service";
import { TimestampService } from "app/main/module/common/timeConstant.service";
import { AssignService } from "../../cassette/assign/assign.service";
import { TranslateService } from "@ngx-translate/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { Globals } from "app/main/module/common/global";
import { CookieService } from "ngx-cookie-service";
import { StorageService } from "app/main/module/common/service/storage.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SignaturePad } from "angular2-signaturepad";
import { Subscription } from "rxjs";
import { title } from "process";
import { id } from "@swimlane/ngx-charts";
import {
    DomSanitizer,
    SafeResourceUrl,
    SafeUrl,
} from "@angular/platform-browser";

@Component({
    selector: "app-edit-ticket",
    templateUrl: "./edit-ticket.component.html",
    styleUrls: ["./edit-ticket.component.scss"],
})
export class EditTicketComponent implements OnInit, AfterViewInit {
    [x: string]: any;
    ticketForm: FormGroup;
    platform = "web";
    @Input()
    min: "D" | null;
    today = new Date();
    isEnterPressed = false;
    hasFirstDataShown: Boolean;
    dobStamp = 0;
    dobString = "";
    deleted: boolean;
    rowId: any;
    memberInfo: any;
    errorMessage: any;
    @ViewChild("input", { static: true }) input: any;
    @ViewChild("filter", { static: true }) filter: any;
    @HostListener("window:resize")
    searchInputSubscription: Subscription;
    message: any;
    inputValue: string;
    filteredPatients: Array<any> = [];
    HASH = "#";
    showNoResultsMessage = false;
    isLoading = false;
    patientlist: Array<any> = [];
    name: string;
    selectLab: string;
    labTimeZone: string;
    minDate: Date;
    uniqueTimestamp: any;
    startAt: any;
    equipmentTypes = [];
    severityTypes = SEVERITY_TYPES;
    assignedToList = [];
    allStatusList = statusType;
    statusList = [];
    @ViewChild(SignaturePad) signaturePad: SignaturePad;
    userId: string;
    signatureBlob: Blob | null = null;
    file: File | null = null;
    previewUrl: SafeResourceUrl | null = null;
    fileUrl: string | null = null;
    isDragging = false;
    files: File[] = [];
    selectedIndex: number = 0;
    previewUrls: { url: string; isNew: boolean; file?: File; type?: string }[] =
        [];
    status: string;
    statusToShowOpen: any[] = [];
    statusToShown: any[] = [];
    MAX_FILES = 5;
    entitledFor: any;
    equipmentType: any;
    signatureField: any;
    ticketId: any;
    role: string = "";
    ticketData = [];
    hasChanges: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<EditTicketComponent>,
        private _formBuilder: FormBuilder,
        public snackBar: MatSnackBar,
        private userService: StorageService,
        private cookieService: CookieService,
        private global: Globals,
        private router: Router,
        @Inject(MAT_DIALOG_DATA) public data: Tickets,
        public translate: TranslateService,
        public paginationService: AssignService,
        public timeStampService: TimestampService,
        public ticketService: TicketsService,
        private tableRefreshService: TableRefreshService,
        private sanitizer: DomSanitizer
    ) {
        this.minDate = new Date();
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    /**
     * On init
     */
    ngOnInit(): void {
        this.equipmentTypes = JSON.parse(
            localStorage.getItem("equipments")
        ).sort();
        this.ticketForm = this._formBuilder.group({
            title: [
                { value: "", disabled: true },
                [Validators.required, Validators.pattern(/^[^\s].*$/)],
            ],
            selectEquipmentType: ["", ""],
            customEquipmentType: ["", [Validators.pattern(/^[^\s].*$/)]],
            selectSeverityType: [
                "",
                [Validators.required, Validators.pattern(/^[A-Za-z0-9 ]/)],
            ],
            assignedTo: [
                "",
                [Validators.required, Validators.pattern(/^[A-Za-z0-9 ]/)],
            ],
            entitledFor: [
                { value: "", disabled: true },
                [Validators.required, Validators.pattern(/^[A-Za-z0-9 ]/)],
            ],
            selectStatus: [
                "",
                [Validators.required, Validators.pattern(/^[A-Za-z0-9 ]/)],
            ],
            description: [
                "",
                [Validators.required, this.wordCountValidator(50)],
            ],
            reasonForIssue: ["", [this.wordCountValidator(50)]],
            resolutionNotes: ["", [this.wordCountValidator(50)]],
            comments: ["", [this.wordCountValidator(50)]],
            signature: ["", ""],
            upload_file: [""],
        });

        this.name = this.userService.getCookie("name");
        this.labTimeZone = localStorage.getItem("defaultTz");
        this.userId = this.userService.getCookie("userId");
        this.role = this.userService.getCookie("role");

        this.timeStampService.timestamp$.subscribe((ts) => {
            this.uniqueTimestamp = ts;
        });

        this.getSingleTicket();

        this.equipmentType = this.ticketForm.get("selectEquipmentType");
        this.signatureField = this.ticketForm.get("signature");

        this.ticketForm.get("selectStatus")?.valueChanges.subscribe(() => {
            this.applySignatureValidation();
        });

        this.ticketForm
            .get("selectEquipmentType")
            ?.valueChanges.subscribe((value) => {
                const customCtrl = this.ticketForm.get("customEquipmentType");

                if (value === "Other") {
                    customCtrl?.setValidators([
                        Validators.required,
                        Validators.pattern(/^[^\s].*$/),
                    ]);
                } else {
                    customCtrl?.clearValidators();
                    customCtrl?.setValue("");
                }

                customCtrl?.updateValueAndValidity();
            });
        // this.setFocus();
    }

    goBack() {
        this.router.navigate(["/tickets/tickets-list"]).then(() => {
            this.ngOnInit();
        });
    }
    toUpperCaseString(str) {
        return str.trim().toUpperCase();
    }

    openSnackBar(message: string, action: string): void {
        this.snackBar.open(message, action, {
            duration: 10000,
        });
    }

    private handleError(error: Error): void {
        this.hasFirstDataShown = false;
        this.openSnackBar(
            //@ts-ignore
            error.error.message,
            this.translateSentence("Common.ok")
        );
        // this.notify.update(error.message, 'error');
    }

    translateSentence(key: string, params?: any): string {
        return this.translate.instant(key, params);
    }

    toLabMidnightTimestamp(date: Date | string, labTimezone: string): number {
        const dateString = moment(date).format("YYYY-MM-DD");
        return moment.tz(dateString, "YYYY-MM-DD", labTimezone).valueOf();
    }

    fromDateValueChange(event: any) {
        this.startAt = event;
    }
    signaturePadOptions: any = {
        minWidth: 1,
        canvasWidth: 300,
        canvasHeight: 150,
    };

    private dataURLToBlob(dataURL: string): Blob {
        const parts = dataURL.split(",");
        const mime = parts[0].match(/:(.*?);/)![1];
        const bstr = atob(parts[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new Blob([u8arr], { type: mime });
    }

    drawComplete() {
        const dataURL = this.signaturePad.toDataURL("image/webp", 0.7);
        this.signatureBlob = this.dataURLToBlob(dataURL);

        // if you still want a preview
        this.ticketForm.get("signature")?.setValue(dataURL);

        // console.log("Signature blob ready:", this.signatureBlob);
    }

    clearSignature() {
        const canvas: HTMLCanvasElement = this.signaturePad["signaturePad"]
            ._canvas as HTMLCanvasElement;

        if (canvas) {
            canvas.width = canvas.width;
            const ctx = canvas.getContext("2d");
            ctx?.clearRect(0, 0, canvas.width, canvas.height);
        }

        this.signaturePad.clear();
        this.ticketForm.get("signature")?.reset();
    }

    getSingleTicket(): void {
        this.id = this.dialogRef.componentInstance.data.id;
        this.hasFirstDataShown = true;

        this.ticketService.getSingleTicket(this.id).subscribe(
            (response: any) => {
                if (response && response.data) {
                    this.ticketData = response.data;
                    this.hasFirstDataShown = false;
                    this.status = this.ticketData[0]?.status;
                    this.entitledFor = this.ticketData[0]?.entitled_for;
                    this.ticketId = this.ticketData[0]?.ticket_id;
                    const equipmentType = this.ticketData[0]?.type_of_equipment;
                    // console.log(this.ticketData);

                    if (this.ticketData[0]?.upload_file) {
                        this.previewUrls = this.ticketData[0]?.upload_file?.map(
                            (url: string) => ({
                                url: url,
                                isNew: false,
                                type: this.getFileType(url),
                            })
                        );
                    }

                    if (this.entitledFor === "support") {
                        this.equipmentType?.clearValidators();
                    } else {
                        this.equipmentType?.setValidators([
                            Validators.required,
                            Validators.pattern(/^[A-Za-z0-9 ]/),
                        ]);
                    }

                    this.equipmentType?.updateValueAndValidity();

                    // this.getAssignedTo(this.ticketData[0]?.entitled_for);

                    this.assignedToList = [
                        {
                            id: this.ticketData[0].assigned_to[0]?.id,
                            name: this.ticketData[0].assigned_to[0]?.name,
                        },
                    ];

                    this.ticketForm.patchValue({
                        title: this.ticketData[0].title,
                        selectSeverityType: this.ticketData[0].severity,
                        assignedTo: this.ticketData[0].assigned_to[0]?.name,
                        selectStatus: this.capitalizeFirstLetter(
                            this.ticketData[0].status
                        ),
                        entitledFor: this.ticketData[0]?.entitled_for
                            ? this.capitalizeFirstLetter(
                                  this.ticketData[0].entitled_for
                              )
                            : "",
                        description: this.ticketData[0].description,
                        reasonForIssue: this.ticketData[0].reason_for_issue,
                        resolutionNotes: this.ticketData[0].resolution_notes,
                        comments: "",
                        signature: this.ticketData[0].signature,
                        // upload_file: this.ticketData[0].upload_file || null,
                    });

                    if (this.equipmentTypes.includes(equipmentType)) {
                        this.ticketForm.patchValue({
                            selectEquipmentType: equipmentType,
                        });
                    } else {
                        this.ticketForm.patchValue({
                            selectEquipmentType: "Other",
                            customEquipmentType: equipmentType,
                        });
                    }

                    this.applySignatureValidation();
                    this.filterStatusList();

                    if (this.ticketData[0]?.signature) {
                        setTimeout(() => {
                            this.signaturePad.fromDataURL(
                                this.ticketData[0].signature
                            );
                        }, 0);
                    }
                }
            },
            (error) => {
                this.hasFirstDataShown = false;
                this.handleError(error);
            }
        );
    }

    updateTicket(): void {
        const apiKeyMap = {
            description: "description",
            reasonForIssue: "reason_for_issue",
            resolutionNotes: "resolution_notes",
            selectStatus: "status",
            selectSeverityType: "severity",
            selectEquipmentType: "type_of_equipment",
            comments: "comments",
            signature: "signature",
            upload_file: "upload_file",
        };

        let updated_on = this.uniqueTimestamp
            ? moment(this.uniqueTimestamp).utc().valueOf().toString()
            : moment.utc().valueOf().toString();
        let resolved_on = this.uniqueTimestamp
            ? moment(this.uniqueTimestamp).utc().valueOf().toString()
            : moment.utc().valueOf().toString();
        let resolved_by = this.name;
        let closed_on = this.uniqueTimestamp
            ? moment(this.uniqueTimestamp).utc().valueOf().toString()
            : moment.utc().valueOf().toString();
        let closed_by = this.name;

        // console.log("signature:", signature);

        const formData = new FormData();
        const currentTicket = this.ticketData.find(
            (t: any) => t.id === this.id
        );
        Object.keys(this.ticketForm.controls).forEach((key) => {
            if (
                [
                    "assignedTo",
                    "title",
                    "entitledFor",
                    "selectEquipmentType",
                    "customEquipmentType",
                ].includes(key)
            )
                return;

            const control = this.ticketForm.get(key);
            const apiKey = apiKeyMap[key] || key;

            const rawNewValue = control?.value;
            const newValue =
                typeof rawNewValue === "string"
                    ? rawNewValue.trim().toLowerCase()
                    : rawNewValue;

            const rawOldValue = currentTicket[apiKey];
            const oldValue =
                typeof rawOldValue === "string"
                    ? rawOldValue.trim().toLowerCase()
                    : rawOldValue;

            if (key === "comments") {
                const oldComments = Array.isArray(rawOldValue)
                    ? rawOldValue
                    : [];
                const lastCommentBody = oldComments.length
                    ? oldComments[
                          oldComments.length - 1
                      ].comment_body?.toLowerCase()
                    : "";

                if (newValue && newValue !== lastCommentBody) {
                    this.hasChanges = true;
                    const finalComments = [
                        ...(this.data.comments ?? []),
                        {
                            comment_body: newValue,
                            commented_by: this.name,
                            commented_on: moment.utc().valueOf().toString(),
                        },
                    ];
                    formData.append("comments", JSON.stringify(finalComments));
                }
                return;
            }

            if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
                if (key === "signature" && newValue?.startsWith("data:image")) {
                    const signature = this.ticketForm.get("signature")?.value;
                    this.hasChanges = true;
                    formData.append(
                        "signature",
                        JSON.stringify({
                            file_name: `${this.uniqueTimestamp}_signature.webp`,
                            file_data: signature,
                        })
                    );
                } else if (key === "upload_file") {
                    if (this.files?.length > 0) {
                        this.hasChanges = true;
                        this.files.forEach((file) => {
                            formData.append("upload_file", file, file.name);
                        });
                    }
                } else {
                    this.hasChanges = true;
                    formData.append(apiKey, newValue || "");
                }
            }
        });

        //Equipment type handling
        const dropdownValue = this.ticketForm.get("selectEquipmentType")?.value;
        const customValue = this.ticketForm.get("customEquipmentType")?.value;

        const finalEquipment =
            dropdownValue === "Other" ? customValue : dropdownValue;

        const oldEquipment = currentTicket?.type_of_equipment;

        if (
            finalEquipment &&
            finalEquipment.toLowerCase() !== oldEquipment?.toLowerCase()
        ) {
            this.hasChanges = true;
            formData.append("type_of_equipment", finalEquipment.trim());
        }

        if (!this.hasChanges) {
            this.openSnackBar(
                this.translateSentence("Tickets.noChanges"),
                this.translateSentence("Common.ok")
            );
            return;
        }

        const status = this.ticketForm.get("selectStatus")?.value;
        formData.append("updated_by", this.name);
        formData.append("updated_on", updated_on);
        if (status === "Resolved") {
            formData.append("resolved_on", resolved_on);
            formData.append("resolved_by", resolved_by);
        }

        if (status === "Closed") {
            formData.append("closed_on", closed_on);
            formData.append("closed_by", closed_by);
        }

        this.hasFirstDataShown = true;

        this.ticketService.updateTicket(formData, this.id).subscribe(
            (response) => {
                if (response && response.status === "success") {
                    this.openSnackBar(
                        this.translateSentence(
                            "Tickets.ticketUpdatedSuccessfully"
                        ),
                        this.translateSentence("Common.ok")
                    );
                    this.hasFirstDataShown = false;
                    this.dialogRef.close();
                    this.tableRefreshService.triggerRefresh();
                } else {
                    this.openSnackBar(
                        this.translateSentence("Tickets.ticketUpdateFailed"),
                        this.translateSentence("Common.ok")
                    );
                }
            },
            (error) => {
                this.handleError(error);
            }
        );
    }

    updateDate(timestamp: string | number | Date): string {
        let x = Number(timestamp);
        const date = new Date(x);

        return date.toLocaleString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
        });
    }

    onFileDrop(event: any): void {
        event.preventDefault();
        this.isDragging = false;

        const droppedFiles = event.dataTransfer.files;
        this.handleFiles(droppedFiles);
    }

    onDragOver(event: any): void {
        event.preventDefault();
        this.isDragging = true;
    }

    onDragLeave(event: any): void {
        event.preventDefault();
        this.isDragging = false;
    }

    onFileDropped(event: any): void {
        const selectedFiles = event.target.files;
        this.handleFiles(selectedFiles);
    }

    handleFiles(fileList: FileList): void {
        const newFiles = Array.from(fileList);

        const existingCount = this.previewUrls.length;

        if (existingCount + newFiles.length > this.MAX_FILES) {
            const allowedCount = this.MAX_FILES - existingCount;

            if (allowedCount <= 0) {
                const msg = this.translateSentence("Tickets.maxFiles", {
                    count: this.MAX_FILES,
                });
                this.openSnackBar(msg, "Ok");
                return;
            }

            newFiles.splice(allowedCount);
            const message = this.translateSentence("Tickets.uploadLimitInfo", {
                existing: existingCount,
                allowed: allowedCount,
            });

            this.openSnackBar(message, "Ok");
        }

        newFiles.forEach((file) => {
            this.files.push(file);
            const reader = new FileReader();
            reader.onload = (e: any) => {
                this.previewUrls = [
                    ...this.previewUrls,
                    {
                        url: e.target.result,
                        isNew: true,
                        file: file,
                        type: file.type.startsWith("image") ? "image" : "video",
                    },
                ];
            };
            reader.readAsDataURL(file);
        });
    }

    removeFile(index: number): void {
        const item = this.previewUrls[index];

        this.previewUrls.splice(index, 1);

        if (this.previewUrls.length === 0) {
            this.selectedIndex = -1;
        } else if (index >= this.previewUrls.length) {
            this.selectedIndex = this.previewUrls.length - 1;
        } else {
            this.selectedIndex = index;
        }

        if (item.isNew) {
            const fileIndex = this.files.findIndex((f) => f === item.file);
            if (fileIndex !== -1) {
                this.files.splice(fileIndex, 1);
            }
        }
    }

    isImage(file: File): boolean {
        return file && file.type.startsWith("image/");
    }

    isVideo(file: File): boolean {
        return file && file.type.startsWith("video/");
    }

    selectFile(index: number) {
        this.selectedIndex = index;
    }

    removeAllFiles() {
        this.files = [];
        this.previewUrls = [];
        this.selectedIndex = 0;
    }

    capitalizeFirstLetter(word: string): string {
        if (!word) return "";
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }

    isImageUrl(url: any): boolean {
        return (
            typeof url === "string" && /\.(jpg|jpeg|png|gif|webp)$/i.test(url)
        );
    }

    isVideoUrl(url: any): boolean {
        return (
            typeof url === "string" && /\.(mp4|mov|avi|mkv|webm)$/i.test(url)
        );
    }

    getFileType(url: string): "image" | "video" {
        const ext = url.split(".").pop()?.toLowerCase();

        if (!ext) return "image";

        const imageExts = ["jpg", "jpeg", "png", "gif", "webp"];
        const videoExts = ["mp4", "mov", "avi", "mkv", "webm"];

        if (imageExts.includes(ext)) return "image";
        if (videoExts.includes(ext)) return "video";

        return "image";
    }

    filterStatusList() {
        // console.log("Current Status:", this.status);
        // console.log(
        //     "Form control value:",
        //     this.ticketForm.get("selectStatus")?.value
        // );

        switch (this.status) {
            case "reopened":
            case "open":
                this.statusList = this.allStatusList.filter(
                    (item) => item === "Inprogress" || item === "Resolved"
                );
                break;
            case "inprogress":
                this.statusList = this.allStatusList.filter(
                    (item) => item === "Resolved"
                );
                break;
            case "resolved":
                this.statusList = this.allStatusList.filter(
                    (item) => item === "Closed" || item === "Reopened"
                );
                break;
            case "closed":
                this.statusList = this.allStatusList.filter(
                    (item) => item === "Reopened"
                );
                break;
            default:
                break;
        }
    }

    getAssignedTo(role) {
        this.hasFirstDataShown = true;
        this.ticketService.getUsers(role).subscribe(
            (response) => {
                if (response && response.status === "success") {
                    this.hasFirstDataShown = false;
                    let responseData = response.data;

                    this.assignedToList = responseData.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }));

                    // console.log(this.assignedToList);
                } else {
                    this.openSnackBar(
                        this.translateSentence("Tickets.noTechnicianInLab"),
                        this.translateSentence("Common.ok")
                    );
                    this.hasFirstDataShown = false;
                }
            },
            (error) => {
                console.log("Inside error block:", error);
                this.hasFirstDataShown = false;
                this.handleError(error);
            }
        );
    }
    private applySignatureValidation(): void {
        const currentStatus = this.ticketForm
            .get("selectStatus")
            ?.value?.toLowerCase();
        const mustHaveSignature =
            (this.role === "support" || this.role === "technician") &&
            currentStatus === "resolved";

        if (mustHaveSignature) {
            this.signatureField?.setValidators([Validators.required]);
        } else {
            this.signatureField?.clearValidators();
        }

        this.signatureField?.updateValueAndValidity();
    }

    wordCountValidator(maxWords: number): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!control.value) return null;
            const trimmed = control.value.trim();

            if (trimmed.length === 0) {
                return { whitespaceOnly: true };
            }

            const wordCount = trimmed.trim().split(/\s+/).length;
            return wordCount > maxWords
                ? { wordLimit: { maxWords, actual: wordCount } }
                : null;
        };
    }

    get selectStatusTriggerText(): string {
        const val = this.ticketForm.get("selectStatus")?.value;
        if (val) {
            return "Tickets." + val.toLowerCase(); // translation key
        } else {
            return "Tickets.pleaseSelect"; // fallback key
        }
    }

    onResize() {
        if (!this.signaturePad) return;

        const canvas = (this.signaturePad as any).signaturePad
            ._canvas as HTMLCanvasElement;
        // console.log("Canvas on resize:", canvas);

        const dataUrl = this.signaturePad.toDataURL();

        if (window.innerWidth <= 768) {
            canvas.width = 250;
            canvas.height = 150;
        } else {
            canvas.width = 300;
            canvas.height = 150;
        }

        const ctx = canvas.getContext("2d");
        ctx?.setTransform(1, 0, 0, 1, 0, 0);

        if (dataUrl) {
            this.signaturePad.fromDataURL(dataUrl);
        }
    }

    ngAfterViewInit(): void {
        this.onResize();
    }
}
